import ButtonLoadingContent from '../../../../shared/Loading/ButtonLoadingContent';

const Actions = (vm) => {
  return (
    <>
      <div className="text-right -mt-0.5">
        <button
          type="button"
          onClick={vm.onForgotPassword}
          className={`text-[10px] hover:underline lg:text-xs ${
            vm.loading ? 'text-gray-500 cursor-not-allowed' : 'text-personalized'
          }`}
          disabled={vm.loading}
        >
          &iquest;Has olvidado la contrase&ntilde;a?
        </button>
      </div>
      <button
        type="submit"
        className={`w-full text-white text-[11px] py-0.5 transition border lg:py-1 lg:text-xs ${
          vm.loading
            ? 'bg-purple-200 cursor-not-allowed'
            : 'border-personalized bg-personalized hover:bg-white hover:text-personalized'
        }`}
      >
        <ButtonLoadingContent loading={vm.loading}>
          <span>Iniciar sesi&oacute;n</span>
        </ButtonLoadingContent>
      </button>
      <button
        type="button"
        onClick={vm.onCreateAccount}
        className={`w-full text-[11px] py-0.5 transition border lg:py-1 lg:text-xs ${
          vm.loading
            ? 'bg-purple-200 cursor-not-allowed text-white border-purple-200'
            : 'bg-white text-personalized border-personalized hover:bg-personalized hover:text-white'
        }`}
        disabled={vm.loading}
      >
        Registrarse
      </button>
    </>
  );
};

export default Actions;
